import { apiAction } from "@client/lib/actions";
import { apiInfoSelector, getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type EntityRef } from "@client/types";
import { type AppState } from "@client/types/AppState";
import { type Dispatch } from "redux";
import { redirect } from "../actions";
import api from "./api";
import { type ContactForm } from "./types";

export enum Actions {
  SubmitBegin = "MODULE_CONTACT_FORM_SUBMIT_BEGIN",
  SubmitFailure = "MODULE_CONTACT_FORM_SUBMIT_FAILURE",
  SubmitSuccess = "MODULE_CONTACT_FORM_SUBMIT_SUCCESS",

  SetModalVisible = "MODULE_CONTACT_FORM_SET_VISIBLE"
}

export type SubmitBeginActionData = EntityRef &
  ContactForm.FormData & {
    showModal: boolean;
  };
export type SubmitSuccessActionData = ContactForm.Api.SubmitResponse;
const _submit = apiAction<AppState, SubmitBeginActionData, ContactForm.Api.SubmitResponse, SubmitSuccessActionData>({
  types: {
    begin: Actions.SubmitBegin,
    failure: Actions.SubmitFailure,
    success: [
      async ({ dispatch, params, getState, res }) => {
        if (params.showModal) return;

        const { id, source, showModal, ...qs } = params;
        await dispatch(
          redirect({
            id,
            source,
            target: TargetSelector.Entity,
            qs: { ...qs, uid: res.userId }
          })
        );
      },
      Actions.SubmitSuccess
    ]
  },
  action: (state: AppState, dispatch: any, args: SubmitBeginActionData) => {
    const { url, baseParams } = apiInfoSelector(state);

    return api.submit({
      baseUrl: url,
      portalId: baseParams.portalId,
      ...args
    });
  }
});

export const submit =
  (ref: EntityRef, data: ContactForm.FormData) => (dispatch: Dispatch<any>, getState: () => AppState) => {
    const afterSubmission = getSettingValueSelector(TargetSelector.Entity, "afterSubmission")(getState(), ref);

    dispatch(
      _submit({
        ...ref,
        ...data,
        showModal: afterSubmission === "modal"
      })
    );
  };

export type SetModalVisibleActionData = EntityRef & {
  isVisible: boolean;
};
export const setModalVisible = (ref: EntityRef, isVisible: boolean) => ({
  type: Actions.SetModalVisible,
  data: { ...ref, isVisible }
});
